<template>
	<div>
		<router-view></router-view>
		<sa-modal-loading ref="globalModalLoading"></sa-modal-loading>
	</div>
</template>

<script>
import { SaModalLoading } from "./app/utility";
export default {
	name: "App",
	components: { SaModalLoading },
	data() {
		return {};
	},
	mounted() {},
	methods: {
		openShowModalLoading() {
			this.$refs.globalModalLoading.show();
		},
		closeShowModalLoading() {
			let me = this;
			setTimeout(() => {
				me.$refs.globalModalLoading.close();
			}, 500);
		},
	},
	provide() {
		return {
			openShowModalLoading: this.openShowModalLoading,
			closeShowModalLoading: this.closeShowModalLoading,
		};
	},
};
</script>

<style></style>
